export const detectTrainingTypeIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete training type" || cleaned === "remove training type") {
        return { intent: "delete_training_type" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) training type/);
    if (deleteMatch) {
        return { intent: "delete_training_type", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create training type") || cleaned.includes("add training type")) {
        return { intent: "create_training_type" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create training type named (.+)/);
    if (createMatch) {
        return { intent: "create_training_type", name: createMatch[1].trim() };
    }

    return null;
};
